    /**
     * Initialize Lenis smooth scrolling
     */
    function initLenis() {
        if (typeof Lenis !== 'undefined') {

            const lenis = new Lenis({
                smoothWheel: true,
                duration: 1.4
            });

            function raf(time) {
                lenis.raf(time);
                requestAnimationFrame(raf);
            }

            requestAnimationFrame(raf);

            // Make lenis available globally
            window.lenis = lenis;

            // console.log('lenis options:', window.lenis.options);
        }
    }

    function initModalLenis(modalContent) {
        // Create Lenis for modal container
        if (!modalContent) return { instance: null, cancel: null };

        // Ensure a dedicated inner content element exists
        let inner = modalContent.querySelector('.lenis-inner');
        if (!inner) {
            inner = document.createElement('div');
            inner.className = 'lenis-inner';
            // move existing children into inner
            while (modalContent.firstChild) {
                inner.appendChild(modalContent.firstChild);
            }
            modalContent.appendChild(inner);
        }

        // Let Lenis control scrolling on the wrapper
        modalContent.style.overflow = 'hidden';

        const instance = new Lenis({
            wrapper: modalContent,
            content: inner,
            smoothWheel: true,
            smoothTouch: true,
            duration: 1.1,
        });

        // Keep ScrollTrigger in sync with modal Lenis
        if (typeof ScrollTrigger !== 'undefined') {
            instance.on('scroll', ScrollTrigger.update);
        }

        // Drive Lenis with RAF
        let rafId = null;
        const loop = (time) => {
            instance.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);

        const cancel = () => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null;
        };

        return { instance, cancel };
    }
